/// <reference path="../../typings/browser.d.ts" />
 
namespace Application.Controllers {
    'use strict';

    import IBlockComplete = Models.IBlockComplete;
    import IConnectionRoom = Models.IConnectionRoom;
    import IBlock = Models.IBlock;
    import ConnRoomTakeResult = Models.ConnRoomTakeResult;
    import Utils = Common.Utils;
    import IFlexEvent = Models.IFlexEvent;
    import IConnectedBlock = Models.IConnectedBlock;
    import IRedundantBlocks = Application.Models.IRedundantBlocks;
    import IStreamPipe = Application.Models.IStreamPipe;
    import NetworkNode = Models.NetworkNode;
    import IFindByTsResults = Application.Models.IFindByTsResults;
    import Block = Application.Models.Block;
    import ConnectionRoomGroup = Models.ConnectionRoomGroup;
    import IConnectionRoomGroup = Application.Models.IConnectionRoomGroup;
    import BlockConnections = Application.Models.BlockConnections;
    
    /**
     * Specific
     */
    interface IBlockSearchBar extends IBlock {
        icon?: string;
        type?: string;
    }

    export interface ISelectedBlocks {
        selectedSource: IBlockComplete;
        selectedDestination: IBlockComplete;
    }

    /**
     * MatrixRoomController class
     */
    export class MatrixRoomController extends ConnectionRoomParentController {
        public static $name: string = 'matrixRoomController';
        public static $inject: string[] = ['$scope',
                                           '$q',
                                           '$cookies',
                                           '$window',
                                           'connectionRoomService',
                                           'blockService',
                                           'ModalService',
                                           '$timeout',
                                           'streamPipeService',
                                           'monitoringRoomService',
                                           'stompService',
                                           '$rootScope',
                                           '$filter',
                                           'aclService',
                                           'messageTranslationsService',
                                           'userService',
                                           'multiBlockService',
                                           'tsProbeService',
                                           'networkNodeService',
                                           'blockConnectionBlocksService',
                                           'connectionRoomGroupService'
                                           ];

        private static ASPECT_RATIO: number = 16 / 9;
        private static TIMEOUT_RESIZING: number = 500;

        public selectedBlocks: ISelectedBlocks;
        public matrixRoom: Models.MatrixRoom;
        public takeDropModalElem: ngModal.IModalObject;
        public firstAdjustmentDone: boolean;
        public showSpinner: boolean;
        public userIsAdmin: boolean;
        private thumbnailsPerBlock: { [blockHref: number]: string; };

        private sourceColumns: number;
        private destinationColumns: number;

        private blocksAvailable: IBlock[];
        private multiBlocks: Models.MultiBlock[];

        private currentSourcesPage: number;
        private sourcesPerPage: number;
        private totalSourcesPages: number;

        private currentDestinationsPage: number;
        private destinationsPerPage: number;
        private totalDestinationPages: number;
        private stompSubscriptions: Services.IEventSubscription[] = [];
        private showingModal: boolean = false;

        private watchers: Function[] = [];

        private filterAccordionsInitiated: boolean;
        private takeModalInputs: ITakeModalInput;
        private takeAllModalInputs: ITakeAllModalInput;
        private editionMode: boolean = false;
        private showSpinnerCounter: number = 0;

        public selectedConnectionRoomGroup: Models.IConnectionRoomGroup;
        protected connectionRoomGroups: ConnectionRoomGroup[];

        constructor($scope: ng.IScope,
                    private $q: ng.IQService,
                    $cookies: ng.cookies.ICookiesService,
                    private $window: ng.IWindowService,
                    connectionRoomService: Services.ConnectionRoomService,
                    protected blockService: Services.BlockService,
                    modalService: ngModal.IModalService,
                    private $timeout: ng.ITimeoutService,
                    private streamPipeService: Services.StreamPipeService,
                    private monitoringRoomService: Services.MonitoringRoomService,
                    private stompService: Services.StompService,
                    private $rootScope: Services.IFlexSettings,
                    private $filter: ng.IFilterService,
                    private aclService: Services.AclService,
                    protected messageTranslationsService: Services.MessageTranslationsService,
                    protected userService: Services.UserService,
                    private multiBlockService: Services.MultiBlockService,
                    private tsprobeService: Services.TsProbeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private blockConnectionBlockService: Services.BlockConnectionBlocksService,
                    private connectionRoomGroupService: Services.ConnectionRoomGroupService) {
            super($scope, connectionRoomService, modalService, $q, $cookies, aclService, messageTranslationsService, () => {
                this.showSpinner = false;
            });

            if (this.$rootScope.isMonitoringOnly && this.userService.getCurrentUser().username !== 'demiurgo') {
                this.$window.location.href = '/#!/';
            }

            this.firstAdjustmentDone = false;
            this.showSpinner = true;
            this.currentSourcesPage = 0;
            this.currentDestinationsPage = 0;
            this.selectedBlocks = {
                selectedDestination: undefined,
                selectedSource: undefined,
            };
            this.thumbnailsPerBlock = {};
            this.connectionRoomGroups = [];
            this.selectedConnectionRoomGroup = undefined;

            this.userService.loadCurrentUser().then((user: Models.IUser) => {
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
            });
            let resizeFn: () => void =  () => {
                this.currentDestinationsPage = 0;
                this.currentSourcesPage = 0;
                this.$timeout(() => {
                    this.adjustPanelsSize();
                });
            };
            angular.element(this.$window).resize(resizeFn);

            this.initFilterAccordions();

            this.$scope.$on('$destroy', () => {
                angular.element(this.$window).off('resize', resizeFn);
                this.destroyWatchers();
                this.destroyStompSubscriptions();
                this.destroyAccordionEvents();
            });
            this.initWatchers($rootScope);
            this.initStompSubscriptions();
        }

        protected loadConnectionRooms(): ng.IPromise<Models.ConnectionRoom> {
            return super.baseLoadConnectionRooms().then(((selectedConnectionRoom: Models.ConnectionRoom) => {
                this.matrixRoom = new Models.MatrixRoom(selectedConnectionRoom, this.connectionRoomService, this.blockService,
                    this.streamPipeService, this.$cookies, this.$q, this.$filter);
                if (selectedConnectionRoom) {
                    this.initializeMatrixRoom();
                }
                return this.selectedConnectionRoom;
            }));
        }

        protected initializeMatrixRoom(): ng.IPromise<Models.IMatrixRoomInfo[]> {
            this.adjustPanelsSize();
            let sourcesPage: number = 0;
            let destinationsPage: number = 0;
            const sourcesSize: number = this.sourcesPerPage <= 6 ? 6 : this.sourcesPerPage;
            const destinationsSize: number = this.destinationsPerPage <= 6 ? 6 : this.destinationsPerPage;
            const sourceFilteredCategories: string[] = this.getCategoriesFromCookies("source");
            const destinationFilteredCategories: string[] = this.getCategoriesFromCookies("destination");
            const sourceFilteredLevel: string = this.getLevelsFromCookies("source");
            const destinationFilteredLevel: string = this.getLevelsFromCookies("destination");
            this.reloadConnectionRoomGroups();
            this.selectedConnectionRoomGroup = undefined;
            this.removeBlockSelection();

            // first we extract first page of sources and sinks with selected filters and if there are more elements, we request everything.
            const promises: ng.IPromise<Models.IMatrixRoomInfo>[] = [];
            promises.push(this.matrixRoom.initializeSourcesInfo(sourcesSize,
                sourcesPage++, sourceFilteredCategories, sourceFilteredLevel));
            promises.push(this.matrixRoom.initializeSinksInfo(destinationsSize,
                destinationsPage++, destinationFilteredCategories, destinationFilteredLevel));

            this.currentSourcesPage = 0;
            this.currentDestinationsPage = 0;
            return this.$q.all(promises).then((resolved: Models.IMatrixRoomInfo[]) => {
                this.$timeout(() => {
                    this.adjustPanelsSize();
                }, MatrixRoomController.TIMEOUT_RESIZING);

                this.matrixRoom.sourcesLoaded = true;
                this.matrixRoom.destinationsLoaded = true;
                this.matrixRoom.hasMoreSources = resolved[0] ? resolved[0].hasMore : undefined;
                this.matrixRoom.hasMoreDestinations = resolved[1] ? resolved[1].hasMore : undefined;

                if (resolved[0] && resolved[0].totalElements > resolved[0].blocks.length) {
                    this.matrixRoom.addAllSourceBlockInfoPageToMatrix().then( (matrix: Models.IMatrixRoomInfo) => {
                        this.matrixRoom.hasMoreSources = matrix.hasMore;
                        this.matrixRoom.backgroundSourcesLoaded = true;
                        this.adjustPanelsSize();
                        this.matrixRoom.updateStreamPipeIdsForDestinations();
                    });
                } else {
                    this.matrixRoom.backgroundSourcesLoaded = true;
                }
                if (resolved[1] && resolved[1].totalElements > resolved[1].blocks.length) {
                    this.matrixRoom.addAllSinkBlockInfoPageToMatrix().then( (matrix: Models.IMatrixRoomInfo) => {
                        this.matrixRoom.hasMoreDestinations = matrix.hasMore;
                        this.matrixRoom.backgroundDestinationsLoaded = true;
                        this.adjustPanelsSize();
                        this.matrixRoom.updateStreamPipeIdsForDestinations();
                    });
                } else {
                    this.matrixRoom.backgroundDestinationsLoaded = true;
                }
                this.matrixRoom.updateStreamPipeIdsForDestinations();
                return resolved;
            });
        }

        public getCategoriesFromCookies(type: string): string[] {
            let categoriesCookieKey: string = type === "source" ?
                Models.BlocksFilter.COOKIE_KEY_PREFIX + Models.BlocksFilter.COOKIE_KEY_SOURCE + Models.BlocksFilter.COOKIE_KEY_CATEGORIES :
                Models.BlocksFilter.COOKIE_KEY_PREFIX + Models.BlocksFilter.COOKIE_KEY_DESTINATION
                    + Models.BlocksFilter.COOKIE_KEY_CATEGORIES;

            const categoriesCookie: string = this.$cookies.get(categoriesCookieKey);
            return categoriesCookie ? categoriesCookie.split('|') : [];
        }

        public getLevelsFromCookies(type: string): string {
            let levelCookieKey: string = type === "source" ?
                Models.BlocksFilter.COOKIE_KEY_PREFIX + Models.BlocksFilter.COOKIE_KEY_SOURCE  + Models.BlocksFilter.COOKIE_KEY_LEVELS :
                Models.BlocksFilter.COOKIE_KEY_PREFIX + Models.BlocksFilter.COOKIE_KEY_DESTINATION  + Models.BlocksFilter.COOKIE_KEY_LEVELS;
            return this.$cookies.get(levelCookieKey);
        }

        /**
         * Opens the modal for creating a new group
         */
        public async addConnectionRoomGroupModal(): Promise <void> {
            this.showConnectionRoomGroupModal(ConnectionRoomGroup.Empty());
        }

        /**
         * Opens the modal for editing the selected group
         */
        public async editConnectionRoomGroupModal(): Promise <void> {
            this.showConnectionRoomGroupModal(this.selectedConnectionRoomGroup);
        }

        /**
         * Deletes the selected connection room
         */
        public async deleteConnectionRoomGroupModal(): Promise<void> {
            this.modalService.showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE GROUP',
                    description: "This action cannot be undone.",
                    name: this.selectedConnectionRoomGroup.name,
                    type: 'warning',
                }
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                  {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        this.connectionRoomGroupService.deleteConnectionRoomGroup(this.selectedConnectionRoomGroup.id).then(() => {
                            this.selectedConnectionRoomGroup = ConnectionRoomGroup.Empty();
                            this.loadConnectionRoomGroupDropdown();
                            $('#saving-spinner').css({display: 'none'});
                        });
                    }
                });
            });
        }

        public async addBlockModal(): Promise <void> {
            const monitorNodes = await this.networkNodeService.getMonitorNodes();
            this.getAvailableBlocks().then((promiseValue: boolean[]) => {
                if (promiseValue) {
                    this.blocksAvailable = this.blocksAvailable.filter((block: IBlock, index: number) => {
                        return !promiseValue[index];
                    });
                }

                this.modalService.showModal({
                    templateUrl: DualListModalController.templateUrl,
                    controller: DualListModalController.$name,
                    inputs: {
                        title: `Select block(s) to add to room ${this.matrixRoom.connectionRoom.name}`,
                        titleElements: `Rest of blocks`,
                        titleSelectedElements: `Blocks in room`,
                        firstColumn: undefined,
                        secondColumn: undefined,
                        selectedElements: this.filterBlocksAlreadyInConnectionRoom(),
                        elements: this.filterBlocksNotInConnectionRoom(monitorNodes),
                        nameProperty: 'name',
                        idProperty: 'id',
                        secondColumnProperty: undefined,
                        noMoreToAddText: 'No blocks to add',
                        noneSelectedText: 'No blocks selected',
                        secondaryInfoCompare: undefined,
                        highlightedId: undefined,
                        type: Controllers.DualListModalController.blockType,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(DualListModalController.ID,
                                                                    { bgclose: false, modal: false, keyboard: false });
                    modalElem.show();
                    modal.close.then((result: { selected: IBlock[], unselected: IBlock[] }) => {
                        if (result) {
                            this.recalculateConnRoomBlocks(result.selected);
                            this.save().then(() => {
                                this.$timeout(() => {
                                    this.filterConnectionRoomGroupBlocks();
                                    this.adjustPanelsSize();
                                });
                            });
                            this.editionMode = false;
                        }
                        modalElem.hide();
                    });
                });
            });
        }

        private enableGroupButtons(){
            return this.selectedConnectionRoomGroup.connectionRoomGroupBlocks.length > 0 && this.selectedBlocks.selectedSource !== undefined && !this.isDestinationGroupLocked() && this.groupBlocksInDestinationConnectionRoom();
        }

        private groupBlocksInDestinationConnectionRoom(): boolean{

            let groupBlocksInDestinationConnectionRoom = true;

            this.selectedConnectionRoomGroup.connectionRoomGroupBlocks.forEach((groupBlocks: number) => {
                groupBlocksInDestinationConnectionRoom = groupBlocksInDestinationConnectionRoom && this.selectedConnectionRoom.sinkBlockHrefs.some((sinkBlocksInRoom: any) => {
                    return sinkBlocksInRoom.blockHref == groupBlocks;
                });
            });
            return groupBlocksInDestinationConnectionRoom;
        }

        private groupExists(){
            return this.selectedConnectionRoomGroup && this.selectedConnectionRoomGroup.name!='' && this.selectedConnectionRoomGroup.name!=undefined
        }

        private isDestinationGroupLocked(){
            return this.blockService.hasLockedBlock( this.selectedConnectionRoomGroup.blocksInfo);
        }

        /**
         * function to display modal of double (destination group takes)
         */
        public takeAllModal(drop = false){

            let dst: IBlockComplete = this.selectedBlocks.selectedDestination;
            let src: IBlockComplete = this.selectedBlocks.selectedSource;

            this.takeAllModalInputs = {
                src: src,
                dst: dst,
                matrixRoom: this.matrixRoom,
                srcThumb: src && src.href ? this.thumbnailsPerBlock[src.id.toString()] : undefined,
                dstThumb: this.thumbnailsPerBlock[this.selectedConnectionRoomGroup.connectionRoomGroupBlocks[0] .toString()],                
                selectedConnectionRoomGroup : this.selectedConnectionRoomGroup,
                drop: drop
            } as ITakeAllModalInput;

            this.modalService.showModal({
                templateUrl: Controllers.TakeAllModalController.templateUrl,
                controller: Controllers.TakeAllModalController.$name,
                inputs: {
                    takeInputs: this.takeAllModalInputs,
                    connectedBlocks: this.matrixRoom.matrixRoomConnectedBlocks
                },
            }).then((modal: ngModal.IModalObject) => {
                let takeDropThumbModalElem: UIkit.ModalElement =
                    UIkit.modal(Controllers.TakeAllModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                takeDropThumbModalElem.show();
                modal.close.then( async (userResponse: any): Promise<any>=> {
                    if(userResponse == true && drop == false){
                        // we perform the first take and wait 1 sec for the pipe to be created, 
                        // then perform the rest of the takes so that they can use that pipe
                        await this.connectionRoomService.take(this.selectedConnectionRoom,
                                src.id, this.selectedConnectionRoomGroup.blocksInfo[0].id);
                        await new Promise(resolve => setTimeout(resolve, 1000)); // sleep 1 second
                        for (let i = 1; i < this.selectedConnectionRoomGroup.blocksInfo.length; i++) {
                            let dest = this.selectedConnectionRoomGroup.blocksInfo[i];
                            await this.connectionRoomService.take(this.selectedConnectionRoom, src.id, dest.id);
                        }
                    }
                    if(userResponse == true && drop == true){
                        this.selectedConnectionRoomGroup.blocksInfo.forEach( (dest) => {
                            this.connectionRoomService.drop(this.selectedConnectionRoom, dest.id, false).then( (result: any)=> {
                                console.log("drop result: ", result);
                            });
                        });                      
                    }           
                
                this.takeModalInputs = undefined;
                });
            });
        }

        /**
         * this is the first function to be executed, called from matrix room view (TAKE button)
         */

        public async takeModal(): Promise<void> {
            let dst: IBlockComplete = this.selectedBlocks.selectedDestination;
            let src: IBlockComplete = this.selectedBlocks.selectedSource;
            if((dst.networkNode.type.id == 4 || dst.networkNode.type.id == 5) && dst.networkNode.config.monitorMode) {
                this.showErrorModal("Take not allowed with a monitor device", "Take with a device configured as monitor is not allowed, please go to the inventory and disable the monitor role in the device");
            }
            else {
                let prevSrc: Models.IConnectedBlock =
                    this.matrixRoom.matrixRoomConnectedBlocks[dst.id] ? this.matrixRoom.matrixRoomConnectedBlocks[dst.id][0] : undefined;

                //destination is redundant ?
                if (prevSrc !== undefined && dst.config.isRedundant !== undefined && src !== undefined) {
                    if(await this.validateRedundancy(src, dst, prevSrc) == false){
                        this.showErrorModal('Take in progress', "The drop could not be done because a take is still completing.\n" +
                            "Please wait a few seconds before trying again.");
                        return;
                    };
                }
                // If we don't have a previous source (so it's a drop) or it's not a DR5000 with redundancy
                this.openTakeModal(src, dst, prevSrc);
            }
        }       

        /**
         * If we have a previous source and the sink is a redundant DR5000
         */
        public async validateRedundancy(src: IBlockComplete, dst: IBlockComplete, prevSrc: Models.IConnectedBlock): Promise<boolean>{
            // Find redundant Blocks of the selected sink
            const redundantBlocks: IRedundantBlocks = await this.blockService.getRedundantBlocks(dst.id);
            let isCorrectSource: boolean = false;
            // Make sure the selected source is the correct one, due to the delay of the enviroment if we do a fast switch the
            // selected source can be the previous one because the take hasn't finished yet.
            if(redundantBlocks.primaryEncoderBlock !==  null ) {
                isCorrectSource = this.matrixRoom.getConnectedSourceForDestination(redundantBlocks.primaryDecoderBlock.id).id === redundantBlocks.primaryEncoderBlock.id;
                if (!isCorrectSource && redundantBlocks.secondaryEncoderBlock !== null && redundantBlocks.secondaryDecoderBlock !== null ) {
                    isCorrectSource = redundantBlocks.secondaryEncoderBlock !== null && this.matrixRoom.getConnectedSourceForDestination(redundantBlocks.primaryDecoderBlock.id).id === redundantBlocks.secondaryEncoderBlock.id;
                }
            }
            // So we have to be sure it's the correct one, otherwise show the error about take in progress
            if (redundantBlocks.primaryEncoderBlock !== null && src.id === this.selectedBlocks.selectedSource.id && isCorrectSource) {
                return true;
            }else {
                return false;
            }
        }

        public savePipeInMatrixRoom(pipe: Models.IPipe): ng.IPromise<Models.IPipe> {
            return this.savePipe(pipe).then(() => {
                    return pipe;
                }
            );
        }

        // Check if destination is a redundant decoder and if the secondary block has a source connected and in that case
        // it performs both drops, if not, it does a normal drop
        public async take(destination: IBlockComplete, source: IBlockComplete, sourceToDisconnect: number, useRedundancy: boolean): Promise<void> {
            if (destination) {
                let redundantBlocks: IRedundantBlocks = await this.blockService.getRedundantBlocks(destination.id);
                //check if drop or switch instead of take
                if (sourceToDisconnect !== undefined) {
                    const isSwitch: boolean = source !== undefined;
                    // If redundant take doesn't finished yet, we show an error
                    if (redundantBlocks.primaryEncoderBlock == null) {
                        this.showErrorModal('Take in progress', "The drop could not be done because a take is still completing.\n" +
                        "Please wait a few seconds before trying again.");
                    } else {
                        if (redundantBlocks.secondaryDecoderBlock !== null) {
                            // If redundant take is done correctly, we can do the drop, so we have to decrease the R symbol from both encoders
                            // and then do both drops.
                            this.matrixRoom.removeMatrixRoomConnection(redundantBlocks.secondaryEncoderBlock.id, destination.id);
                            this.drop(redundantBlocks.secondaryEncoderBlock.id, redundantBlocks.secondaryDecoderBlock.id, isSwitch).then(() => {
                                this.drop(redundantBlocks.primaryEncoderBlock.id, destination.id, isSwitch).then(() => {
                                    this.performAfterDropTasks(source, destination, useRedundancy, sourceToDisconnect);
                                });
                            });
                        } else {
                        this.drop(sourceToDisconnect, destination.id, isSwitch).then(() => {
                            this.performAfterDropTasks(source, destination, useRedundancy, sourceToDisconnect);
                        });
                        }
                    }
                } else {
                    this.takeAndUpdateMatrix(destination, source, null, useRedundancy);
                }
            }
        }

        public showErrorModal(reason?: string, description?: string){
            this.modalService.showModal({
                templateUrl: Application.Controllers.ErrorModalController.templateURL,
                controller: Application.Controllers.ErrorModalController.$name,
                inputs: {
                    title: reason,
                    description: description,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ErrorModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    this.showingModal = false;
                });
            });
        }

        public async takeAndUpdateMatrix(destination: IBlockComplete, source: IBlockComplete, switchOp: boolean = false, useRedundancy: boolean = false): Promise<void> {
            let isRedundant: boolean = false;
            // If it's a DR5000 and redundancy was selected we have to do one extra take for the redundant block of the decoder
            if ( destination.config.isRedundant !== undefined && source.config.redundancyGroup !== undefined && useRedundancy) {
                // first find the id of the encoder for the secondary take
                let secondaryTake = Common.Utils.getRedundantIdFromEncoderGroup(source);
                isRedundant = true;
                let sourceBlock: IBlockComplete =  this.matrixRoom.getSourceBlock(secondaryTake);
                if(sourceBlock === undefined) {
                    this.takeWithoutRedundancy(source, destination, switchOp);
                }
                else {
                    // Find the redundant block of the decoder
                    let blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(destination.networkNodeHref));
                    let redundantBlockInNode: IBlock = blocksInNode.filter((x: IBlock) => x.config.isRedundant)[0];
                    // do both takes once we have updated the blocks
                    this.takeWithRedundancy(source, destination, secondaryTake, redundantBlockInNode, switchOp);
                }
            }
            else {
                if(destination.config.isRedundant !== undefined && source.config.redundancyGroup) {
                    isRedundant = true;
                    let secondaryTake = Common.Utils.getRedundantIdFromEncoderGroup(source);
                    this.connectionRoomService.dropLock(secondaryTake, destination.config.redundantBlockId);
                }
                this.takeWithoutRedundancy(source, destination, switchOp);
            }

        }

        public drop(source: number, destination: number, isSwitch: boolean): ng.IPromise<void> {
            return this.connectionRoomService
                        .drop(this.selectedConnectionRoom, destination, isSwitch)
                        .then((connRoom: IConnectionRoom) => {
                            this.selectedConnectionRoom = connRoom;
                            this.matrixRoom.dropEvent(source, destination);
                        });
        }

        public takeWithoutRedundancy(source: IBlockComplete, destination: IBlockComplete, switchOp: boolean): ng.IPromise<void> {
            return this.connectionRoomService.take(this.selectedConnectionRoom, source.id, destination.id)
                .then((connRoomTakeResult: ConnRoomTakeResult) => {
                    this.matrixRoom.refreshBlocks([this.selectedBlocks.selectedSource, this.selectedBlocks.selectedDestination]);
                    if (!switchOp) this.selectedBlocks.selectedSource = undefined;
                    let connectionRoom: IConnectionRoom = connRoomTakeResult.connRoom;
                    if (!connRoomTakeResult.ok) {
                        this.showErrorModal('Invalid connection',  this.messageTranslationsService.getMessageAsStringByKeySync(
                            connRoomTakeResult.errorMessage,  [source.name, destination.name]) );
                    } else {
                        //  VTS Forward || after normal take operation, we check if affects to any existing VTS Forward connection
                        if(destination.networkNode.type.id === 18) {
                            this.connectionRoomService.findVtsForwardBlocks(source.id, destination.id).then(
                                (forwardBlocks)=>{
                                    setTimeout(() => {
                                        forwardBlocks.forEach( (block: any) => {
                                            this.blockService.getConnectedBlocks(block.id).then( (connectedBlocks)=> {
                                                for (const connectedBlock of connectedBlocks) {
                                                    // if it has a multicast ip in the config, check if it is probed and do the reprobe.
                                                    if (connectedBlock.config.ts) {
                                                        this.reprobe(connectedBlock);
                                                    }
                                                }
                                            });
                                            this.reprobe(block);
                                            // get pipes from forward blocks and proceed to retake all of them
                                            this.streamPipeService.getStreamPipesByBlockList([block.id]).then(
                                                (res)=>{
                                                    res[0].forEach( (pipe: Models.StreamPipe) =>{
                                                        this.connectionRoomService.reTake(pipe.sourceBlockId, pipe.sinkBlockId, this.selectedConnectionRoom);
                                                    } );
                                                }
                                            );
                                        });
                                    }, 2000);
                                }
                            );
                        }
                        this.selectedConnectionRoom = connectionRoom;
                        this.matrixRoom.updateMatrixRoom(connectionRoom);
                    }
                }).catch(() => {
                this.selectedBlocks.selectedSource = undefined;
                this.selectedBlocks.selectedDestination = undefined;
                this.loadConnectionRooms();
            });
        }

        public reprobe(block: Block): ng.IPromise<void> {
            return this.tsprobeService.getConnectedProbeByBlockId(block.id).then((res: IFindByTsResults) => {
                if (res) {
                    this.tsprobeService.disconnectProbeByBlockId(block.id).then((stopped: Models.ProbeOperationResult) => {
                        if (stopped) {
                            setTimeout(() => {
                                this.tsprobeService.connectProbeByBlockId(block.id, res.defaultTsProbe.tsProbe.networkNodeId).catch((reason: ngCustom.IReason) => {
                                    const result: Models.ProbeOperationResult = {
                                        result: false,
                                        errors: ["Could not make connection with TNS"],
                                        message: "",
                                    };
                                    this.showProbeErrors(result);
                                });
                            }, 6000);
                        }
                    });
                }
            });
        }

        public takeWithRedundancy(source: IBlockComplete, destination: IBlockComplete, secondaryTake: number, redundantBlockInNode: IBlock, switchOp: boolean): ng.IPromise<void> {
            return this.connectionRoomService.take(this.selectedConnectionRoom, secondaryTake, redundantBlockInNode.id).then((connRoomTakeResult: ConnRoomTakeResult) => {
                this.connectionRoomService.take(this.selectedConnectionRoom, source.id, destination.id)
                    .then((connRoomTakeResult: ConnRoomTakeResult) => {
                        // refresh the redundant encoders blocks to update the R symbol
                        this.blockService.findById(source.id);
                        this.blockService.findById(secondaryTake);
                        this.matrixRoom.refreshBlocks([this.selectedBlocks.selectedSource, this.selectedBlocks.selectedDestination, this.matrixRoom.getSourceBlock(secondaryTake), source]);
                        if (!switchOp) this.selectedBlocks.selectedSource = undefined;
                        let connectionRoom: IConnectionRoom = connRoomTakeResult.connRoom;
                        if (!connRoomTakeResult.ok) {
                            this.showErrorModal('Invalid connection', this.messageTranslationsService.getMessageAsStringByKeySync(
                                connRoomTakeResult.errorMessage,  [source.name, destination.name]) );
                        } else {
                            this.selectedConnectionRoom = connectionRoom;
                            this.matrixRoom.updateMatrixRoom(connectionRoom);
                        }
                    }).catch(() => {
                    this.selectedBlocks.selectedSource = undefined;
                    this.selectedBlocks.selectedDestination = undefined;
                    this.loadConnectionRooms();
                });
            });
        }
        public dropDestination(pipe: Models.IPipe, index: number): ng.IPromise<Models.IPipe|ngCustom.IReason> {
            return this.disconnectDestination(pipe, index)
                .then((element: Models.IPipe) => {
                    this.matrixRoom.updateConnectionRoom(this.selectedConnectionRoom);
                    // if this was the last destination, removes the whole pipe
                    if (pipe.destinations.every(
                        (dest: Models.IDestination, i: number, array: Models.IDestination[]): boolean => { return dest.empty; })) {
                        this.removePipePromise(pipe).then(() => {
                            this.matrixRoom.updateConnectionRoom(this.selectedConnectionRoom);
                        });
                    }
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return reason;
                });
        }

        public dropSource(source?: number): void {
            let pipesWithSource: Models.IPipe[] = this.selectedConnectionRoom.pipes.filter(
                (pipe: Models.IPipe) => { return pipe.source === source.toString(); }
            );
            if (pipesWithSource.length > 0) {
                let pipe: Models.IPipe = pipesWithSource[0];
                this.qService.all(pipe.destinations.map(
                    (destination: Models.IDestination, index: number) => {
                        destination.destination = '';
                        destination.status = false;
                        destination.empty = true;
                        return this.dropDestination(pipe, index);
                    }
                )).then(
                    () => {
                        this.matrixRoom.updateConnectionRoom(this.selectedConnectionRoom);
                    }
                );
            } else {
                this.messageTranslationsService.alertOnError('error.dropping.matrix.room.sourceNotFound');

            }
        }

        public save(): ng.IPromise<{}[]> {
            return this.saveSelectedConnectionRoom()
                .then((connRoom: IConnectionRoom) => {
                    return this.matrixRoom.updateMatrixRoom(connRoom);
                });
        }

        public onThumbnailChangedPanel(blockHref: number, thumbnailUrl: string): void {
            this.thumbnailsPerBlock[blockHref] = thumbnailUrl;
        }

        public selectBlock(block: IBlockComplete): void {
            if(block.locked == true){
                return;
            }
            if (block.type === 'source') {
                if(this.selectedConnectionRoomGroup && this.selectedConnectionRoomGroup.id) {
                    if(this.selectedConnectionRoomGroup.name != ""){
                        this.selectedBlocks.selectedSource  = block;
                    }                    
                    return;
                }
                if (this.selectedBlocks.selectedDestination !== undefined || this.selectedConnectionRoomGroup) {
                    if (this.selectedBlocks.selectedSource === block) {
                        this.selectedBlocks.selectedSource = undefined;
                    } else if (!this.sourceAlreadyConnected(block.id)) {
                        this.selectedBlocks.selectedSource  = block;
                    }
                } else {
                    this.selectedBlocks.selectedSource = undefined;
                }
            } else {
                if (this.selectedBlocks.selectedDestination === block) {
                    this.selectedBlocks.selectedDestination = undefined;
                    if (this.selectedBlocks.selectedSource !== undefined)
                        this.selectedBlocks.selectedSource = undefined;
                } else {
                    if (this.selectedBlocks.selectedSource && this.matrixRoom.getConnectedSourceForDestination(block.id) && 
                    this.matrixRoom.getConnectedSourceForDestination(block.id).id === this.selectedBlocks.selectedSource.id)
                        this.selectedBlocks.selectedSource = undefined;
                    this.selectedBlocks.selectedDestination  = block;
                }
            }
        }

        public isBlockSelected(block: IBlockComplete): boolean {
            if (block.type === 'source') {
                return this.selectedBlocks.selectedSource === block;
            } else {
                return this.selectedBlocks.selectedDestination === block;
            }
        }

        public toggleLock(block: IBlockComplete, value?: boolean): void {
            if (!block.locked) {
                this.lockModal(block);
            } else {
                this.unlockModal(block);
            }
        }

        public removeBlock(blockId: number): void {
            this.modalService.showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                    title: `Remove block`,
                    description: `The block will be removed from this room. This action cannot be undone.`,
                    name: '',
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(ConfirmModalController.ID, {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        this.selectedBlocks.selectedSource = undefined;
                        this.selectedBlocks.selectedDestination = undefined;
                        this.matrixRoom.pushBlockIfMissing(blockId);
                        this.removeBlockHref(blockId);
                        this.save().then(() => {
                            this.$timeout(() => {
                                this.filterConnectionRoomGroupBlocks();
                                this.adjustPanelsSize();
                            });
                        });
                    }
                });
            });
        }

        public searchSourceText(): void {
            if (this.matrixRoom.sourceBlockFilter) {
                this.matrixRoom.sourceBlockFilter.searchText();
                this.currentSourcesPage = 0;
                this.$timeout(() => {
                    this.adjustPanelsSize();
                });
            }
        }

        public searchDestinationText(): void {
            if (this.matrixRoom.destinationBlockFilter) {
                this.matrixRoom.destinationBlockFilter.searchText();
                this.currentDestinationsPage = 0;
                this.$timeout(() => {
                    this.adjustPanelsSize();
                });
            }
        }

        public changeLevel(level: string, type: string): void {
            if (type === 'source') {
                this.matrixRoom.sourceBlockFilter.changeLevel(level);
                this.currentSourcesPage = 0;
            } else {
                this.matrixRoom.destinationBlockFilter.changeLevel(level);
                this.currentDestinationsPage = 0;
            }
            this.$timeout(() => {
                this.adjustPanelsSize();
            });
        }

        public changeBlockCategories(block: IBlockComplete, categoriesFromModal: Directives.ICategoriesModalResult): void {
            this.matrixRoom.changeBlockCategories(block, categoriesFromModal).then(() => {
                this.$timeout(() => {
                    this.adjustPanelsSize();
                });
            });
        }

        public changeCategory(category: Models.Category, type: string): void {
            if (type === 'source') {
                this.matrixRoom.sourceBlockFilter.changeCategory(category);
                this.currentSourcesPage = 0;
            } else {
                this.matrixRoom.destinationBlockFilter.changeCategory(category);
                this.currentDestinationsPage = 0;
            }
            this.$timeout(() => {
                this.adjustPanelsSize();
            });
        }

        public changeAllCategories(type: string): void {
            if (type === 'source') {
                this.matrixRoom.sourceBlockFilter.changeAllCategories();
                this.currentSourcesPage = 0;
            } else {
                this.matrixRoom.destinationBlockFilter.changeAllCategories();
                this.currentDestinationsPage = 0;
            }
            this.$timeout(() => {
                this.adjustPanelsSize();
            });
        }

        public changeSourcesPage(page: number): void {
            this.currentSourcesPage = page;
            this.$timeout(() => {
                this.adjustPanelsSize();
            });
        }

        public changeDestinationsPage(page: number): void {
            this.currentDestinationsPage = page;
            this.$timeout(() => {
                this.adjustPanelsSize();
            });
        }

        public getSourcePages(): number[] {
            return Common.Utils.range(this.totalSourcesPages);
        }

        public getDestinationPages(): number[] {
            return Common.Utils.range(this.totalDestinationPages);
        }

        public getTotalSourcePages(): void {
            if (this.sourcesPerPage > 0 && this.matrixRoom && 
                    this.matrixRoom.sourceBlockFilter && this.matrixRoom.sourceBlockFilter.filtered) {
                this.totalSourcesPages = Math.floor(this.matrixRoom.sourceBlockFilter.filtered.length / this.sourcesPerPage);
                if (this.matrixRoom.sourceBlockFilter.filtered.length % this.sourcesPerPage !== 0) {
                    this.totalSourcesPages++;
                }
            }
            if (this.currentSourcesPage + 1 > this.totalSourcesPages && this.currentSourcesPage > 0) {
                this.currentSourcesPage = this.totalSourcesPages - 1;
            }
        }

        public getTotalDestinationPages(): void {
            if (this.destinationsPerPage > 0 && this.matrixRoom && 
                    this.matrixRoom.destinationBlockFilter && this.matrixRoom.destinationBlockFilter.filtered) {
                this.totalDestinationPages = Math.floor(this.matrixRoom.destinationBlockFilter.filtered.length / this.destinationsPerPage);
                if (this.matrixRoom.destinationBlockFilter.filtered.length % this.destinationsPerPage !== 0) {
                    this.totalDestinationPages++;
                }
            }
            if (this.currentDestinationsPage + 1 > this.totalDestinationPages && this.currentDestinationsPage > 0) {
                this.currentSourcesPage = this.totalDestinationPages - 1;
            }
        }

        public toggleEditionMode(): void {
            if (this.userCanWriteRoom) {
                this.editionMode = !this.editionMode;
            } else {
                this.editionMode = false;
            }
        }

        public showSources(): boolean {
            return this.matrixRoom && this.matrixRoom.sourceBlockFilter ? 
                // pages
                (this.currentSourcesPage === 0 || (this.currentSourcesPage > 0 && !this.matrixRoom.hasMoreSources)) &&
                // interacted with tags
                (!this.matrixRoom.sourceBlockFilter.touched || 
                    this.matrixRoom.sourceBlockFilter.touched && this.matrixRoom.backgroundSourcesLoaded) &&
                // searchInput
                (!this.matrixRoom.sourceBlockFilter.searchInput || 
                    this.matrixRoom.sourceBlockFilter.searchInput && !this.matrixRoom.hasMoreSources) &&
                this.matrixRoom.sourcesLoaded && this.matrixRoom.sourceBlockFilter.filtered.length > 0 : false;
        }

        public showSourcesSpinner(): boolean {
            return (this.currentSourcesPage > 0 || 
                (this.matrixRoom && this.matrixRoom.sourceBlockFilter && this.matrixRoom.sourceBlockFilter.searchInput)) &&
                this.matrixRoom.hasMoreSources ||
                this.matrixRoom && this.matrixRoom.sourceBlockFilter && 
                    this.matrixRoom.sourceBlockFilter.touched && !this.matrixRoom.backgroundSourcesLoaded;
        }

        public showNoSourcesFound(): boolean {
            return !this.showSourcesSpinner() && 
                this.matrixRoom && this.matrixRoom.sourcesLoaded && this.matrixRoom.sourceBlockFilter && 
                (this.matrixRoom.sourceBlockFilter.filtered.length === 0 ||
                this.matrixRoom.sourceBlockFilter.touched && !this.matrixRoom.backgroundSourcesLoaded);
        }

        public showDestinations(): boolean {
            return this.matrixRoom && this.matrixRoom.destinationBlockFilter ? 
                // pages
                (this.currentDestinationsPage === 0 || (this.currentDestinationsPage > 0 && !this.matrixRoom.hasMoreDestinations)) &&
                // interacted with tags
                (!this.matrixRoom.destinationBlockFilter.touched || 
                    this.matrixRoom.destinationBlockFilter.touched && this.matrixRoom.backgroundDestinationsLoaded) &&
                // searchInput
                (!this.matrixRoom.destinationBlockFilter.searchInput || 
                    this.matrixRoom.destinationBlockFilter.searchInput && !this.matrixRoom.hasMoreDestinations) &&
                this.matrixRoom.destinationsLoaded && this.matrixRoom.destinationBlockFilter.filtered.length > 0 : false;
        }

        public showDestinationsSpinner(): boolean {
            return (this.currentDestinationsPage > 0 || 
                (this.matrixRoom && this.matrixRoom.destinationBlockFilter && this.matrixRoom.destinationBlockFilter.searchInput)) &&
                this.matrixRoom.hasMoreDestinations ||
                this.matrixRoom && this.matrixRoom.destinationBlockFilter && 
                    this.matrixRoom.destinationBlockFilter.touched && !this.matrixRoom.backgroundDestinationsLoaded;
        }

        public showNoDestinationsFound(): boolean {
            return !this.showDestinationsSpinner() && 
                this.matrixRoom && this.matrixRoom.destinationsLoaded && this.matrixRoom.destinationBlockFilter &&
                (this.matrixRoom.destinationBlockFilter.filtered.length === 0 ||
                this.matrixRoom.destinationBlockFilter.touched && !this.matrixRoom.backgroundDestinationsLoaded);
        }

        public onSelected (selectedItem: any) {
            selectedItem = undefined;
        }

        private sourceAlreadyConnected(blockId: number): boolean {
            return this.matrixRoom.matrixRoomConnectedBlocks[blockId].some((connectedBlock: IConnectedBlock) =>
                connectedBlock.id === this.selectedBlocks.selectedDestination.id);
        }

        private async openTakeModal(src: IBlockComplete, dst: IBlockComplete, prevSrc: Models.IConnectedBlock) {
            let prevSrcId: number = prevSrc ? prevSrc.id : undefined;
            // find connected primary encoder block for switching
            if (prevSrc !== undefined && dst.config.isRedundant !== undefined) {
                let redundantBlocks: IRedundantBlocks = await this.blockService.getRedundantBlocks(dst.id);
                if  (redundantBlocks.primaryEncoderBlock !== null) {
                    prevSrcId = redundantBlocks.primaryEncoderBlock.id;
                }
            }
            this.takeModalInputs = {
                src: src,
                dst: dst,
                hasCustomTakeParameters: src ? this.hasCustomTakeParameters(dst) || this.hasCustomTakeParameters(src) : this.hasCustomTakeParameters(dst),
                customTakeParametersInSrc: src ? this.hasCustomTakeParameters(src) : false,
                matrix: this.matrixRoom,
                prevSrcId: prevSrcId ? prevSrcId : undefined,
                prevSrcName: prevSrc ? prevSrc.name : undefined,
                srcThumb: src && src.href ? this.thumbnailsPerBlock[src.id.toString()] : undefined,
                dstThumb: this.thumbnailsPerBlock[dst.id.toString()],
                prevSrcThumb: prevSrc && prevSrc.href ? this.thumbnailsPerBlock[prevSrc.id.toString()] : undefined,
                matrixRoom: this.matrixRoom,
            } as ITakeModalInput;
            this.modalService.showModal({
                templateUrl: Controllers.TakeModalController.templateUrl,
                controller: Controllers.TakeModalController.$name,
                inputs: {
                    takeInputs: this.takeModalInputs,
                },
            }).then((modal: ngModal.IModalObject) => {
                let takeDropThumbModalElem: UIkit.ModalElement =
                    UIkit.modal(Controllers.TakeModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                takeDropThumbModalElem.show();
                modal.close.then( async (userResponse: any): Promise<any>=> {
                    takeDropThumbModalElem.hide();
                    if (userResponse.userResponse) {
                        // if passphrase is not empty, update it in block connections before take (VIRT_SRT_RX_CALL only)
                        if(!angular.equals(userResponse.presetPathConnection, {}) ){
                            if(userResponse.presetPathConnection.parameters.passphrase){
                                await this.updatePresetPathPassphrase(userResponse.presetPathConnection);
                            }
                        }

                        if(!angular.equals(userResponse.customParameters, {})) {
                            // VSRT TX LISTENER
                            if(src.blockType.naturalKey == Models.BlockTypeNaturalKey.VIRT_SRT_TX_LSTN){
                                await this.addCustomParameters(src, userResponse, BlockConnections.DIRECTION_OUTPUT);
                            }
                            
                            // VSRT RX LISTENER
                            if(dst.blockType.naturalKey == Models.BlockTypeNaturalKey.VIRT_SRT_RX_LSTN){
                                await this.addCustomParameters(dst, userResponse, BlockConnections.DIRECTION_INPUT);
                            }
                        }

                        await this.take(dst, src, this.takeModalInputs.prevSrcId, modal.scope.useRedundancy);
                            if(userResponse.lockedComment != {}){
                                // to avoid locking destination before drop is finished, we use a timeout
                                setTimeout( () =>{
                                    this.updateBlock(userResponse.dst, userResponse.lockedComment);
                                }, 2000 );
                            }
                    }
                    this.takeModalInputs = undefined;
                });
            });
        }

        private async addCustomParameters(block: Application.Models.IBlockComplete, userResponse: any, direction: string) {
            let blockConnection: Models.IBlockConnections = block.blockConnections
                .filter(blockConnection => blockConnection.direction === direction && blockConnection.connectionTypeName == "SRT")[0];
            await this.updatePassphrase(userResponse.customParameters.passphrase, blockConnection);

            if (direction === BlockConnections.DIRECTION_OUTPUT) {
                block.config.outputTargetPort = userResponse.customParameters.port;
            } else if (direction === BlockConnections.DIRECTION_INPUT) {
                block.config.inputTargetPort = userResponse.customParameters.port;
            }
            block.config.ip = userResponse.customParameters.ip;
            block.config.latency = userResponse.customParameters.latency;
            await this.blockService.updateBlock(block);
        }

        private updateBlock(block: IBlock, lockedComment: string){

            block.locked = true;
            block.lockedComment = lockedComment;
            block.lockedUser = this.userService.getCurrentUser().username;
            block.lockedTimestamp = new Date();

            try{
                this.blockService.updateBlock(block).then((block) => {
                    this.unselectBlock(block);
                }).catch((res: any) => {
                    console.log(res);
                });
            } catch (error) {
                console.log(error);
            }
        
        }

        private async updatePassphrase(passphrase: string, blockConnection: Models.IBlockConnections) {
            const updatedBlockConnection: Models.IUpdateBlockConnection = {
                id: blockConnection.id,
                targetPorts: blockConnection.targetPorts,
                parameters: {passphrase: passphrase},
            };
            await this.updateBlockConnection(updatedBlockConnection);

        }

        private async updatePresetPathPassphrase(presetPathConnection: Models.IBlockConnection) {
            const updatedBlockConnection: Models.IUpdateBlockConnection = {
              id: presetPathConnection.id,
              targetPorts: presetPathConnection.targetPorts,
              parameters: {passphrase: presetPathConnection.parameters.passphrase},
            };
            await this.updateBlockConnection(updatedBlockConnection);
      
          }

        private async updateBlockConnection(updatedBlockConnection: Application.Models.IUpdateBlockConnection) {
            await this.blockConnectionBlockService.updateBlockConnection(updatedBlockConnection).catch(
              (res) => {
                  console.log("Error updating passphrase: ", res);
              }
            );
        }

        private addBlockHref(blocks: IBlockComplete[]): void {
            blocks.forEach((block: IBlockComplete) => {
                this.selectedConnectionRoom.blockHrefs.push({
                    blockHref: Common.Utils.idFromHref(block.href).toString(),
                    type: block.type,
                    name: block.name,
                });
            });
        }

        private recalculateConnRoomBlocks(blocks: IBlockComplete[]): void {
            this.selectedConnectionRoom.blockHrefs = [];
            this.addBlockHref(blocks);
        }

        private removeBlockHref(blockId: number): void {
            let found: number = -1;
            this.selectedConnectionRoom.blockHrefs.forEach(
                (element: Models.IConnectionRoomBlock, index: number) => {
                    if (Common.Utils.idFromHref(element.blockHref) === blockId) {
                        found = index;
                    }
            });
            this.selectedConnectionRoom.blockHrefs.splice(found, 1);
        }

        private getAvailableBlocks(): ng.IPromise<boolean[]> {
            return this.qService.all([
                this.blockService.findSourceBlocksPromise(),
                this.blockService.findSinkBlocksPromise(),
                this.multiBlockService.getAllMultiBlocks(),
            ]).then((res: Object[]) => {
                let sourceBlocks: IBlock[] = res[0] as IBlock[];
                let sinkBlocks: IBlock[] = res[1] as IBlock[];
                this.multiBlocks = res[2] as Models.MultiBlock[];
                
                sourceBlocks.forEach(
                    (elem: IBlockSearchBar) => {
                        elem.type = 'source';
                    }
                );
                sinkBlocks.forEach(
                    (elem: IBlockSearchBar) => {
                        elem.type = 'destination';
                    }
                );
                
                this.blocksAvailable = sourceBlocks.concat(sinkBlocks);
                if (this.multiBlocks.length > 0) {
                    return this.qService.all(
                        this.blocksAvailable.map((block: IBlock) => {
                            return this.multiBlockService.isInMultiBlock(block.id);
                        })
                    );
                } else {
                    let promiseValue: boolean[] = [];
                    this.blocksAvailable.forEach((value: IBlock, index: number) => {
                        promiseValue[index] = false;
                    });
                    return promiseValue;
                }
            });
        }

        private filterBlocksNotInConnectionRoom(monitorNodes: NetworkNode[]):  IBlock[] {

            if (this.blocksAvailable)
                return this.blocksAvailable.filter((value: IBlock) => {
                        return !this.matrixRoom.inSources(Common.Utils.idFromHref(value.href)) &&
                            (!this.matrixRoom.inDestinations(Common.Utils.idFromHref(value.href)) && !value.config.isRedundant);
                    }
                ).filter(( block: IBlock) => {
                    return !monitorNodes.some( (node: NetworkNode) => {
                        return (block.networkNodeHref == node.id.toString());
                    })
                })
            else
                return [];
        }

        private filterBlocksAlreadyInConnectionRoom():  IBlock[] {
            if (this.blocksAvailable) {
                return this.blocksAvailable.filter((value: IBlock) => {
                        return this.matrixRoom.inSources(Common.Utils.idFromHref(value.href)) ||
                            this.matrixRoom.inDestinations(Common.Utils.idFromHref(value.href));
                    }
                );
            }
            else
                return [];
        }

        private adjustPanelsSize(): void {
            if (!this.filterAccordionsInitiated) {
                this.initFilterAccordions();
                this.filterAccordionsInitiated = true;
            } 
            
            const leftPanelContainerHeight: number = $('.mr-left-panel-container').height();
            const rightPanelContainerHeight: number = $('.mr-right-panel-container').height();

            const panelToolbarHeight: number = 49;

            const filterSources: number = $('#panel-filters-sources').height() || 37;
            const filterDestinations: number = $('#panel-filters-destinations').height() || 37;

            const dotsSources: number = $('#panel-dots-sources').height() || 20;
            const dotsDestinations: number = $('#panel-dots-destinations').height() || 20;

            const sourcesHeight: number = leftPanelContainerHeight - panelToolbarHeight - filterSources - dotsSources;
            const destinationsHeight: number = rightPanelContainerHeight - panelToolbarHeight - filterDestinations - dotsDestinations;

            $('#panel-destinations, #panel-sources').height(Math.max(sourcesHeight, destinationsHeight));
            $('#panel-sources, #panel-destinations').css('min-height', 190);

            $('#panel-blocks-sources').height($('#panel-sources').height() - filterSources - dotsSources);
            $('#panel-blocks-destinations').height($('#panel-destinations').height() - filterDestinations - dotsDestinations);

            let viewportWidth: number = $('#page_content_inner').width();
            if (viewportWidth !== undefined && viewportWidth > 345) {
                if (viewportWidth < 716) {
                    $('#panel-destinations').css('height', '100%');
                    $('#panel-sources').css('height', '100%');
                }

                if ($('#panel-sources') !== undefined && $('#panel-sources').length > 0) {
                    let srcWidth: number = $('#panel-sources').width();
                    if (srcWidth !== undefined) {
                        let columns = this.sourceColumns !== undefined ? Number(this.sourceColumns) : 4;
                        this.adjustThumbnailsSizeHelper('.mr-left-thumb', columns);

                    }
                }

                if ($('#panel-destinations') !== undefined && $('#panel-destinations').length > 0) {
                    let dstWidth: number = $('#panel-destinations').width();

                    if (dstWidth !== undefined) {
                        let columns = this.destinationColumns !== undefined ? Number(this.destinationColumns) : 4;
                        this.adjustThumbnailsSizeHelper('.mr-right-thumb', columns);
                    }
                }


            }

            this.$timeout(() => {
                this.firstAdjustmentDone = true;
            }, 250);
            
        }

        private adjustThumbnailsSizeHelper(thumbsSelector: string, numCols: number): void {

            let margin: number = 1; // percentage
            let thumbs: JQuery = $(thumbsSelector);
            // set thumb width calculated as percentage

            let heightForBlocks: number;
            let widthForBlocks: number;
            let maxColumns: number;

            if (thumbsSelector === '.mr-left-thumb') {
                maxColumns = this.sourceColumns !== undefined ? Number(this.sourceColumns) : 4;
                heightForBlocks = $('#panel-blocks-sources').height();
                widthForBlocks = $('#panel-sources').width();
            } else {
                maxColumns = this.destinationColumns !== undefined ? Number(this.destinationColumns) : 4;
                heightForBlocks = $('#panel-blocks-destinations').height();
                widthForBlocks = $('#panel-destinations').width();
            }

            let marginPx: number =  (widthForBlocks / 100) * margin;
            let thumbWidth: number = (100 - margin * (numCols - 1)) / numCols;
            Utils.setCssClassAttribute(thumbsSelector, "width", thumbWidth + '%');
            thumbWidth = (widthForBlocks / numCols) - marginPx;

            // if resulting width (in pixels) is lower than 150px, set it to the 100%
            this.takeNameOut(thumbWidth);

            if (thumbWidth > 150) {
                let numRows: number;
                let blockHeight: number = thumbWidth / MatrixRoomController.ASPECT_RATIO;
                Utils.setCssClassAttribute(thumbsSelector, "height", blockHeight + 'px');
                Utils.setCssClassAttribute(thumbsSelector, "margin-right", margin + '%');
                Utils.deleteCssClassAttributeMatching(thumbsSelector + `:nth-child`);
                Utils.setCssClassAttribute(thumbsSelector + `:nth-child(${numCols}n)`, "margin-right", "0px");
                // 8px is the margin bottom, it's on the class
                numRows = Math.floor(heightForBlocks / (thumbWidth / MatrixRoomController.ASPECT_RATIO + 8));
                if (numRows === 0) numRows = 1;

                if (thumbsSelector === '.mr-left-thumb') {
                    this.sourcesPerPage = numRows * numCols;
                    this.getTotalSourcePages();
                } else {
                    this.destinationsPerPage = numRows * numCols;
                    this.getTotalDestinationPages();
                }

                if (thumbs !== undefined) {
                    // This is the only point where we really need the loaded thumbnails
                    if ((heightForBlocks <= blockHeight + margin) && (numCols < maxColumns)) {
                        this.adjustThumbnailsSizeHelper(thumbsSelector, numCols + 1);
                        return;
                    }
                }
            } else if (!this.showSpinner && numCols > 1) {
                this.adjustThumbnailsSizeHelper(thumbsSelector,numCols - 1);
            }
            this.resizeThumbnailInfo(thumbsSelector, thumbWidth);
        }

        private resizeThumbnailInfo(thumbSelector: string, thumbWidth: number): void {
            if (thumbWidth < 190) {
                Utils.setCssClassAttribute(`${thumbSelector} .ba-thumbnail-top-text, ${thumbSelector} .ba-thumbnail-bottom-right-text`,
                    "font-size", '12px');
                Utils.setCssClassAttribute(`${thumbSelector} .material-icons.ba-thumbnail-toolbar-action`, "font-size", '18px');
            } else if (thumbWidth < 320) {
                Utils.setCssClassAttribute(`${thumbSelector} .ba-thumbnail-top-text, ${thumbSelector} .ba-thumbnail-bottom-right-text`,
                    "font-size", '14px');
                Utils.setCssClassAttribute(`${thumbSelector} .material-icons.ba-thumbnail-toolbar-action`, "font-size", '18px');
            } else {
                Utils.setCssClassAttribute(`${thumbSelector} .ba-thumbnail-top-text, ${thumbSelector} .ba-thumbnail-bottom-right-text`,
                    "font-size", '16px');
                Utils.setCssClassAttribute(`${thumbSelector} .material-icons.ba-thumbnail-toolbar-action`, "font-size", '22px');
            }
        }

        private takeNameOut(thumbWidth: number): void {
            if (thumbWidth < 225) {
                Utils.setCssClassAttribute('.ba-thumbnail-bottom-right', 'display', 'block!important');
                Utils.setCssClassAttribute('.ba-thumbnail-toolbar-status-panel', 'display', 'none!important');
                Utils.setCssClassAttribute('.ba-thumbnail-toolbar-icons-panel', 'max-width', '100%!important');
            } else {
                Utils.setCssClassAttribute('.ba-thumbnail-bottom-right', 'display', 'none!important');
                Utils.setCssClassAttribute('.ba-thumbnail-toolbar-status-panel', 'display', 'block!important');
                Utils.setCssClassAttribute('.ba-thumbnail-toolbar-icons-panel', 'max-width', '65%!important');
            }
        }

        private async takeMessageReceived(flexEvent: Models.IFlexEvent): Promise<void> {
            let takeEventData: Models.ITakeEventData =  flexEvent.data;
            // check if block is a dr5000 with redundancy and take the primary block
            let decoderBlock: IBlock = await this.blockService.findById(takeEventData.sink);
            if (decoderBlock.config.isRedundant) {
                let blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(decoderBlock.networkNodeHref));
                decoderBlock = blocksInNode.filter( (x: IBlock) => !x.config.isRedundant)[0];
            }
            if (this.matrixRoom.containsBlocks([takeEventData.source, decoderBlock.id])
                && await this.userHasBlockPermission(decoderBlock.id)) {
                this.matrixRoom.takeEvent(takeEventData.source, takeEventData.sink, takeEventData.streamPipeId);
                if (this.takeModalInputs && this.takeModalInputs.dst) {
                    // Modal is open, perhaps we need to update the data
                    let prevSrc: Models.IConnectedBlock = this.matrixRoom.getConnectedSourceForDestination(this.takeModalInputs.dst.id);
                    this.takeModalInputs.prevSrcId = prevSrc ? prevSrc.id : undefined;
                    this.takeModalInputs.prevSrcThumb =
                        prevSrc && prevSrc.href ? this.thumbnailsPerBlock[prevSrc.id.toString()] : undefined;
                }
            } else if (this.matrixRoom.containsBlock(takeEventData.sink) 
                && !this.matrixRoom.containsBlock(takeEventData.source) 
                && await this.userHasBlockPermission(takeEventData.sink)) {
                this.matrixRoom.takeEventNotContainingSink(takeEventData.source, takeEventData.sink, takeEventData.streamPipeId);
            }
        }

        private async dropMessageReceived(flexEvent: Models.IFlexEvent): Promise<void> {
            let dropEventData: Models.IDropEventData =  flexEvent.data;
            // check if block is a dr5000 with redundancy and take the primary block
            let decoderBlock: IBlock = await this.blockService.findById(dropEventData.sink);
            if(decoderBlock.config.isRedundant) {
                let blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(decoderBlock.networkNodeHref));
                decoderBlock = blocksInNode.filter( (x: IBlock) => !x.config.isRedundant)[0];
                let redundantEncoderBlock: IBlock = await this.blockService.findById(dropEventData.source);
                let redundantEncoderBlocks: string[] = redundantEncoderBlock.config.redundancyGroup.redundancyIds.split("-");
                // refresh the redundant encoders blocks to update the R symbol
                this.matrixRoom.refreshBlocks([this.matrixRoom.getSourceBlock(Number(redundantEncoderBlocks[0])), this.matrixRoom.getSourceBlock(Number(redundantEncoderBlocks[1]))]);
            }
            if (this.matrixRoom.containsBlock(decoderBlock.id) ) {
                this.selectedConnectionRoom.pipes.forEach((pipe: Models.IPipe) => {
                    pipe.destinations.forEach((destination: Models.IDestination) => {
                        if (destination.streamPipeHref &&
                            Common.Utils.idFromHref(destination.streamPipeHref) === dropEventData.streamPipeId) {
                            destination.destination = '';
                        }
                    });
                });
                this.matrixRoom.dropEvent(dropEventData.source, dropEventData.sink, true);
                if (this.takeModalInputs && this.takeModalInputs.dst) {
                    // Modal is currently open, perhaps we need to update the data
                    let prevSrc: Models.IConnectedBlock = this.matrixRoom.getConnectedSourceForDestination(this.takeModalInputs.dst.id);
                    if (prevSrc === undefined && this.takeModalInputs.prevSrcId !== undefined) {
                        this.takeModalInputs.prevSrcId = undefined;
                        this.takeModalInputs.prevSrcThumb = undefined;
                    }
                }
            }
        }

        private saveBlockMessageReceived(flexEvent: Models.IFlexEvent): void {
            let saveBlockEventData: Models.ISaveBlockEventData =  flexEvent.data;
            if (this.matrixRoom.containsBlock(saveBlockEventData.id)) {
                this.matrixRoom.updateBlock(saveBlockEventData);
                this.adjustPanelsSize();
                this.$scope.$apply();
            }
        }

       private saveStreamPipeMessageReceived(flexEvent: Models.IFlexEvent): void {
           let saveStreamPipeData: Models.IStreamPipeSavedEventData = flexEvent.data;
           if (saveStreamPipeData.active === false && this.matrixRoom.containsDestination(saveStreamPipeData.sink)) {
                this.selectedConnectionRoom.pipes.forEach((pipe: Models.IPipe) => {
                    pipe.destinations.forEach((destination: Models.IDestination) => {
                        if (destination.streamPipeHref &&
                            Common.Utils.idFromHref(destination.streamPipeHref) === saveStreamPipeData.id) {
                            destination.destination = '';
                        }
                    });
                });
                this.matrixRoom.dropEvent(saveStreamPipeData.source, saveStreamPipeData.sink, true);
            }
        }

       private failedStreamPipeMessageReceived(flexEvent: Models.IFlexEvent): void {
           let failedStreamPipeData: Models.IStreamPipeSavedEventData = flexEvent.data;
           if (this.matrixRoom.containsDestination(failedStreamPipeData.sink)) {
                this.selectedConnectionRoom.pipes.forEach((pipe: Models.IPipe) => {
                    pipe.destinations.forEach((destination: Models.IDestination) => {
                        if (!this.showingModal && destination.streamPipeHref &&
                            Common.Utils.idFromHref(destination.streamPipeHref) === failedStreamPipeData.id) {
                            destination.destination = '';
                            this.showingModal = true;
                            this.showErrorModal('Invalid connection', this.errorCodeText(failedStreamPipeData.errorCode, failedStreamPipeData.errorMessage));
                        }
                    });
                });
                this.matrixRoom.dropEvent(failedStreamPipeData.source, failedStreamPipeData.sink, true);
            }
       }

       private networkNodeOrganizationChangedReceived(flexEvent: Models.IFlexEvent): void {
           let organizationChangedData: Models.INetworkNodeOrganizationChangeEventData = flexEvent.data;
           if ( organizationChangedData.organizationId === this.userService.getCurrentUser().organizationId) {
               this.loadConnectionRooms();
           } else {
               this.matrixRoom.removeBlocksByNodeId(organizationChangedData.id);
           }

       }

        private lockModal(block: IBlockComplete): void {
            this.modalService.showModal({
                    templateUrl: Application.Controllers.GenericPromptModalController.templateUrl,
                    controller: Application.Controllers.GenericPromptModalController.$name,
                    inputs: {
                        title: 'Lock device',
                        description: '',
                        inputName: 'Reason',
                        inputRequired: false,
                        inputValue: '',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let promptModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GenericPromptModalController.id,
                                                    {bgclose: false, modal: false, keyboard: false});
                    promptModalElem.show();
                    modal.close.then((result: Controllers.IGenericPromptModalResult) => {
                        if (result !== undefined) {
                            this.matrixRoom.toggleLock(block, this.blockService, result.answer, true);
                            // Unselect after locking to avoid strange behaviors like taking with a locked device
                            this.unselectBlock(block);
                        }
                    });
                });
        }

        private unlockModal(block: IBlockComplete): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.UnlockModalController.templateURL,
                controller: Application.Controllers.UnlockModalController.$name,
                inputs: {
                    block: block,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.UnlockModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        this.matrixRoom.toggleLock(block, this.blockService, undefined, false);
                        // Unselect after locking to avoid strange behaviors like taking with a locked device
                        this.unselectBlock(block);
                    }
                });
            });
        }

        private unselectBlock( block: IBlockComplete ): void {
            if (Block.equals(block, this.selectedBlocks.selectedSource))
                this.selectedBlocks.selectedSource = undefined;
            
            if (Block.equals(block, this.selectedBlocks.selectedDestination)) {
                this.selectedBlocks.selectedDestination = undefined;
                this.selectedBlocks.selectedSource = undefined;
            }
        }

        private initStompSubscriptions(): void {
            this.stompSubscriptions.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.TAKE_OPERATION, (event: Models.IFlexEvent) => {
                    this.takeMessageReceived(event);
                }),
                this.stompService.register(Models.FLEXO_COMPONENT, Models.DROP_OPERATION, (event: Models.IFlexEvent) => {
                    this.dropMessageReceived(event);
                }),
                this.stompService.register(Models.FLEXO_COMPONENT, Models.SAVE_STREAM_PIPE_OPERATION, (event: Models.IFlexEvent) => {
                    this.saveStreamPipeMessageReceived(event);
                }),
                this.stompService.register(Models.FLEXO_COMPONENT, Models.SAVE_BLOCK_OPERATION, (event: Models.IFlexEvent) => {
                    this.saveBlockMessageReceived(event);
                }),
                this.stompService.register(Models.FLEXO_COMPONENT, Models.FAILED_STREAM_PIPE_OPERATION, (event: Models.IFlexEvent) => {
                    this.failedStreamPipeMessageReceived(event);
                }),
                this.stompService.register(Models.NETWORK_NODES_COMPONENT, Models.NETWORK_NODE_ORGANIZATION_CHANGED_OPERATION,
                    (event: IFlexEvent) => {
                    this.networkNodeOrganizationChangedReceived(event);
                }),
                this.stompService.register(Models.NETWORK_NODES_COMPONENT, Models.WORKFLOW_CHANGED_OPERATION, (event: IFlexEvent) => {
                    let id: number = event.data.id;
                    if (event.data.workflowMode === Models.WORKFLOW_MODE_MAINTENANCE) {
                        this.matrixRoom.removeBlocksByNodeId(id);
                    }
                })
            );
        }

        private destroyStompSubscriptions(): void {
            this.stompSubscriptions.forEach((subscription: Services.IEventSubscription) => {
                this.stompService.unregister(subscription);
            });
        }

        private initWatchers($rootScope: ng.IRootScopeService): void {
            this.watchers.push(
                this.$scope.$watch('mcr.selectedConnectionRoom', (newCR: IConnectionRoom, oldCR: IConnectionRoom) => {
                    if (newCR !== undefined && (oldCR === undefined || newCR.href !== oldCR.href)) {
                        this.firstAdjustmentDone = false;
                        let cookieVal: string = Common.Utils.idFromHref(this.selectedConnectionRoom.href).toString();
                        this.$cookies.put(this.cookieKey, cookieVal, Controllers.ConnectionRoomController.COOKIE_OPTIONS);
                        if (oldCR !== undefined && newCR.href !== oldCR.href) {
                            this.loadConnectionRooms();
                        }
                        this.checkUserCanWriteRoom( this.selectedConnectionRoom );
                    }
                })
            );

            this.watchers.push(
                this.$scope.$watch('mcr.matrixRoom.sourceBlockFilter.searchInput', (newVal: string, oldVal: string) => {
                    if (newVal !== oldVal) {
                        this.searchSourceText();
                    }
                })
            );

            this.watchers.push(
                this.$scope.$watch('mcr.matrixRoom.destinationBlockFilter.searchInput', (newVal: string, oldVal: string) => {
                    if (newVal !== oldVal) {
                        this.searchDestinationText();
                    }
                })
            );

            this.watchers.push($rootScope.$watch('miniSidebarActive', (newValue: boolean, oldValue: boolean) => {
                if (newValue !== oldValue)
                    this.$timeout(() => {
                        this.adjustPanelsSize();
                    }, MatrixRoomController.TIMEOUT_RESIZING);
            }));

            this.watchers.push($rootScope.$watch('settings.sourceColumns', (newValue: number, oldValue: number) => {
                if (!this.sourceColumns)
                    this.sourceColumns = newValue;
                if (newValue !== undefined && newValue !== oldValue) {
                    this.sourceColumns = newValue;
                    this.currentSourcesPage = 0;
                    this.adjustThumbnailsSizeHelper('.mr-left-thumb', newValue);
                }
            }));

            this.watchers.push($rootScope.$watch('settings.destinationColumns', (newValue: number, oldValue: number) => {
                if (!this.destinationColumns)
                    this.destinationColumns = newValue;
                if (newValue !== undefined && newValue !== oldValue) {
                    this.destinationColumns = newValue;
                    this.currentDestinationsPage = 0;
                    this.adjustThumbnailsSizeHelper('.mr-right-thumb', newValue);
                }
            }));

            this.watchers.push(
              this.$scope.$watch('mcr.selectedConnectionRoomGroup', (newCRG: IConnectionRoomGroup, oldCRG: IConnectionRoomGroup) => {
                  if ((newCRG && (oldCRG == undefined || newCRG.id !== oldCRG.id)) || (newCRG == undefined && oldCRG != undefined)) {
                      this.selectedBlocks.selectedDestination = undefined;
                      this.filterConnectionRoomGroupBlocks();
                      this.currentDestinationsPage = 0;
                      this.getTotalDestinationPages();
                  }
                  this.$rootScope.$broadcast('connectionGroupRoom', this.selectedConnectionRoomGroup);
              })
            );
        }

        private destroyWatchers(): void {
            this.watchers.forEach((watcher: Function) => {
                watcher();
            });
        }

        private errorCodeText(errorCode: string, errorMessage: string): string {
            if (errorCode === 'MVP-ADAPTER-1' || errorCode === 'MVP-ADAPTER-2')
                return this.messageTranslationsService.getMessageAsStringByKeySync( errorCode );
            else return errorMessage;
        }
        
        private initFilterAccordions(): void {
            let srcAccordion: string = '#src_accordion';
            let dstAccordion: string = '#dst_accordion';
            if (($(srcAccordion).length === 0 && $(dstAccordion).length === 0)) {
                this.$timeout(() => {
                    // delay accordions until we have the elements ready (slow connections issue)
                    this.initFilterAccordions();
                }, 300);
                return;
            }
            this.destroyAccordionEvents();
            this.$timeout(() => {
                let srcAccordionCookie: string = this.$cookies.get('src_accordion_state');
                let dstAccordionCookie: string = this.$cookies.get('dst_accordion_state');
                UIkit.accordion(srcAccordion, { showfirst: (srcAccordionCookie === 'true'), animate: false });
                UIkit.accordion(dstAccordion, { showfirst: (dstAccordionCookie === 'true'), animate: false });
                $(srcAccordion).on('toggle.uk.accordion', (event: BaseJQueryEventObject, active: string) => {
                    this.$timeout(() => {
                        this.adjustPanelsSize();
                        this.$cookies.put('src_accordion_state', active);
                    }, 150);
                });
                $(dstAccordion).on('toggle.uk.accordion', (event: BaseJQueryEventObject, active: string) => {
                    this.$timeout(() => {
                        this.adjustPanelsSize();
                        this.$cookies.put('dst_accordion_state', active);
                    }, 150);
                });
                this.adjustPanelsSize();
            });
        }
 
        private destroyAccordionEvents(): void { 
            let srcAccordion: string = '#src_accordion';
            let dstAccordion: string = '#dst_accordion';
            $(srcAccordion).off('toggle.uk.accordion');
            $(dstAccordion).off('toggle.uk.accordion');
        }

        private async userHasBlockPermission(blockId: number): Promise<boolean> {
            return await this.aclService.getPermissions('blocks', blockId).then((evaluatedAcls: Models.IEvaluatedAcl) => {
                if (evaluatedAcls.read) {
                    return true;
                }
                return false;
            });
        }

        private showProbeErrors(result: Models.ProbeOperationResult): void {
            const errors: string = result.errors && result.errors.length > 0 && result.errors[0] !== "" ?
                result.errors.join("\r\n") : "TNS Generic error";
            this.modalService
                .showModal({
                    templateUrl: Controllers.ConfirmModalController.templateURL,
                    controller: Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'Probe error',
                        description: errors,
                        name: '',
                        type: 'warning',
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                    });
                });
        }

        private showConnectionRoomGroupModal(connectionRoomGroup: ConnectionRoomGroup) {
            const destinationBlocks: Models.IBlockComplete[] = [];
            if (this.matrixRoom.destinationBlockFilter) {
                this.matrixRoom.destinationBlockFilter.unfiltered.forEach(block => destinationBlocks.push(block));
            }

            const currentConnectionRoomGroup = {...connectionRoomGroup};

            this.modalService.showModal({
                templateUrl: ConnectionRoomGroupModalController.templateUrl,
                controller: ConnectionRoomGroupModalController.$name,
                inputs: {
                    connectionRoomGroup: currentConnectionRoomGroup,
                    blocks: destinationBlocks,
                    connectionRoomId:this.selectedConnectionRoom.id,
                    connectionRoomGroups:this.connectionRoomGroups
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(ConnectionRoomGroupModalController.ID,
                  { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((updatedConnectionRoomGroup: ConnectionRoomGroup) => {
                    if(updatedConnectionRoomGroup) {
                        this.connectionRoomGroupService.saveConnectionRoomGroup(updatedConnectionRoomGroup).then((connectionRoomGroup) => {
                            this.reloadConnectionRoomGroups();
                            this.selectedConnectionRoomGroup = connectionRoomGroup;
                            this.filterConnectionRoomGroupBlocks();
                            this.adjustPanelsSize();
                        });
                    }
                    modalElem.hide();
                });
            });
        }

        private reloadConnectionRoomGroups() {
            this.loadConnectionRoomGroupDropdown();
            this.filterConnectionRoomGroupBlocks();
        }

        private filterConnectionRoomGroupBlocks() {
            if (this.matrixRoom.destinationBlockFilter) {
                this.matrixRoom.destinationBlockFilter.customFilter = undefined;
                if (this.selectedConnectionRoomGroup && this.selectedConnectionRoomGroup.id) {
                    this.addDestinationBlocksFilter();
                }
                this.matrixRoom.destinationBlockFilter.searchText();
                if(this.selectedConnectionRoomGroup)
                    this.selectedConnectionRoomGroup.blocksInfo = this.matrixRoom ? this.matrixRoom.destinationBlockFilter.filtered : [];
            }
        }

        private addDestinationBlocksFilter() {
            this.matrixRoom.destinationBlockFilter.customFilter =
              (block: IBlock) => {
                  return this.selectedConnectionRoomGroup.connectionRoomGroupBlocks.some(
                    (id) => {
                        return id == block.id;
                    });
              };
        }

        private loadConnectionRoomGroupDropdown() {
            this.connectionRoomGroups = [];
            this.connectionRoomGroups.push(ConnectionRoomGroup.Empty());
            this.connectionRoomGroupService.findConnectionRoomGroupByRoomId(this.selectedConnectionRoom.id).then((connectionRoomGroups: ConnectionRoomGroup[]) => {
                this.connectionRoomGroups = this.connectionRoomGroups.concat(connectionRoomGroups);
              }
            );
        }

        /**
         * Checks if you must show aditional parameters in the take modal form
         * @private
         */
        public hasCustomTakeParameters(block: IBlock): boolean {
            return block.blockType.naturalKey === Models.BlockTypeNaturalKey.VIRT_SRT_RX_LSTN || block.blockType.naturalKey === Models.BlockTypeNaturalKey.VIRT_SRT_TX_LSTN;
        }

        /**
         * Executes all the actions that should be performed after a drop
         * @param source source block (when performing a switch)
         * @param destination destination block
         * @param useRedundancy boolean indicating if the take should be redundant (when performing a switch)
         * @param sourceToDisconnect previous source block
         * @private
         */
        private performAfterDropTasks(source: Application.Models.IBlockComplete, destination: Application.Models.IBlockComplete, useRedundancy: boolean, sourceToDisconnect: number) {
            if (source) {
                this.takeAndUpdateMatrix(destination, source, true, useRedundancy);
                this.selectedBlocks.selectedSource = this.matrixRoom.getSourceBlock(sourceToDisconnect);
            } else {
                this.removeBlockSelection();
            }
        }

        /**
         * Deselects the source and destination blocks
         * @private
         */
        private removeBlockSelection() {
            this.selectedBlocks.selectedSource = undefined;
            this.selectedBlocks.selectedDestination = undefined;
        }
    }
}
